import { render, staticRenderFns } from "./ForumRules.vue?vue&type=template&id=d19b5cec&scoped=true&"
import script from "./ForumRules.vue?vue&type=script&lang=js&"
export * from "./ForumRules.vue?vue&type=script&lang=js&"
import style0 from "./ForumRules.vue?vue&type=style&index=0&id=d19b5cec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19b5cec",
  null
  
)

export default component.exports